import { action } from 'satcheljs';
import { FolderForestTreeType } from 'owa-favorites-types';
import DistinguishedFolderIdName from 'owa-service/lib/contract/DistinguishedFolderIdName';
import FindFolderParentWrapper from 'owa-service/lib/contract/FindFolderParentWrapper';

export const onFindFolderSuccess = action(
    'ON_FIND_FOLDER_RESPONSE',
    (
        rootFolder: FindFolderParentWrapper,
        distinguishedFolderId: DistinguishedFolderIdName,
        treeType: FolderForestTreeType,
        principalSMTPAddress: string,
        displayName: string,
        folderTreeIdentifier: string,
        userIdentity?: string
    ) => ({
        rootFolder,
        distinguishedFolderId,
        treeType,
        principalSMTPAddress,
        displayName,
        folderTreeIdentifier,
        userIdentity,
    })
);
